import React, {useContext} from 'react';
import TableComponent from '../TableComponent'
import { UsersContext } from '../../../context/users-context';
import { AllEquipsContext } from '../../../context/allEquips-context';
import { SummaryTabIndex, MainTabPanelIndex } from '../../../model/constants';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';
import {useSetCurrEquip} from '../../../hooks/useSetCurrEquip'

export default function EquipRegistryTable(props) {
  console.log("render EquipRegistryTable");

  const [usersState] = useContext(UsersContext);
  const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);
  const setCurrEquip = useSetCurrEquip();

  const navigate = useNavigate();
  const handleRowClick = async (event, row) => {
    if (event.target.localName === 'a')
      return;

    const equipInfo = row.EquipName;
    if (equipInfo === '')
      return;

    setCurrEquip(equipInfo, 'SETEQUIPINFO');
    allEquipsDispatch({ type: 'ADDSELECTEDEQUIPS', payload: equipInfo }); 
    navigate("/info/summary/main", {state: { tabIndex: SummaryTabIndex, panelIndex: MainTabPanelIndex}});
  };
  
  const columns = [
    { field: 'Link', title: 'Jira', width: 100, render: rowData => <Link href={rowData.Link} color="inherit" target="_blank">{rowData.Link.split('/').pop()}</Link> },
    { field: 'SerialNumber', title: 'Номер', sorting: true, width: 100 },
    { field: 'Complex', title: 'Тип комплекса', sorting: true, width: 200 },
    { field: 'Region', title: 'Регион', width: 100 },
    { field: 'Hospital', title: 'ЛПУ' },
    { field: 'Address', title: 'Адрес' },
    { field: 'Equipment', title: 'Комплектность' },
    { field: 'SupportEndDate', title: 'Поддержка до', type: 'date', dateSetting: { locale: navigator.language }, width: 150 },
    { field: 'Status', title: 'Статус', width: 100 },
    { field: 'EquipName', title: 'Комплекс', width: 100 },
  ];

  return (
    <TableComponent
      columns={columns}
      data={props.data}
      onRowClick={handleRowClick}
     />
  );
}